import { render, staticRenderFns } from "./Members2024.vue?vue&type=template&id=62b00e2e&scoped=true"
import script from "./Members2024.vue?vue&type=script&lang=js"
export * from "./Members2024.vue?vue&type=script&lang=js"
import style0 from "./Members2024.vue?vue&type=style&index=0&id=62b00e2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b00e2e",
  null
  
)

export default component.exports